<template>
<div id="app">
    <div class="top-menu navbar navbar-inverse navbar-fixed-top">
        <div class="top-menu-body container">
            <ul class="nav nav-pills">
                <li role="presentation">
                    <img class="logo" src="~@/assets/logo.png" height="34" />
                </li>
                <li role="presentation"><a @click="goAnchor('#aboutus')" href="#aboutus">关于我们</a></li>
                <li role="presentation"><a @click="goAnchor('#procut')" href="#procut">相关产品</a></li>
                <li role="presentation"><a @click="goAnchor('#news')" href="#news">新最动态</a></li>
                <li role="presentation"><a @click="goAnchor('#join')" href="#join">加入我们</a></li>
                <li role="presentation"><a @click="goAnchor('#contect')" href="#contect">联系我们</a></li>
            </ul>
        </div>
    </div>
    <router-view />
    <div class="foot-bar">
        <div class="foot-content container">
            <div class="foot-menu row">
                <div class="col-md-6">
                    <img class="logo" src="~@/assets/logo.png" />
                    <!-- <p>极大众智慧服务你我</p> -->
                </div>
                <div class="col-md-6" id="contect">
                    <form class="form-horizontal">
                        <div class="form-group">
                            <label for="inputEmail3" class="col-sm-2">Email</label>
                            <div class="col-sm-10">esin.zhong@hotmail.com</div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="coppyright">
                2021©{{ companyName }} <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">粤ICP备2021023232号-1</a>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "App",
    data() {
        return {
            companyName: "广州极有米网络科技有限公司",
        };
    },
    methods: {
        goAnchor(selector) {
            var anchor = this.$el.querySelector(selector)
            document.documentElement.scrollTop = anchor.offsetTop
        }
    },
};
</script>

<style>
body {
    padding: 0px;
    margin: 0px;
}

#app {}

.top-menu {
    background-color: #333;
    height: 50px;
}

.top-menu-body {
    height: 50px;
    color: #fff;
    font-size: 16px;
    /* line-height: 50px; */
    padding: 3px;
    margin: auto;
}

.top-menu-body a {
    color: #999;
}

.foot-bar {
    margin-top: 10px;
    border-top: 1px solid #aaa;
    color: #666;
}

.foot-bar a {
    color: #666;
}

.foot-menu {
    border-bottom: 1px solid #eee;
    padding: 10px 0;
}

.foot-menu .logo {
    height: 40px;
}

.foot-content .coppyright {
    text-align: center;
    line-height: 24px;
    padding: 10px 0;
    margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue